export const NOTIFICATION_SOURCE_SERVICE: number = 0;
export const NOTIFICATION_TYPE_RECRUIT: number = 1;
export const NOTIFICATION_TYPE_SYSTEM: number = 5;
export const NOTIFICATION_TYPE_MESSAGE: number = 4;
export const CHAT_TYPE_SYSTEM: number = 4;
